(ns frontend.view.modals.curtains.kpi-member-curtain.events
  (:require
   [promesa.core :as p]
   [frontend.conn :as conn]
   [frontend.logging :as logging]))

(defn add-member!
  [edit-state dialog-state target invite? on-success!]
  (let [{:keys [kpi-member/asset kpi-member/contact common/owner]} @edit-state
        msg {:db/id  (:db/id target)
             :member {:asset-id   asset
                      :contact-id contact
                      :owner-id   owner}}]
    (swap! dialog-state assoc :processing true)
    (-> (conn/sendp! (if invite?
                       :kpi-category/add-member-and-invite
                       :kpi-category/add-member)
                     msg)
        (p/then (fn [_]
                  (swap! dialog-state dissoc :processing)
                  (when (fn? on-success!)
                    (on-success!))))
        (p/catch (fn [e]
                   (swap! dialog-state dissoc :processing)
                   (logging/error "Failed to add member"))))))
